import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData, DevelopmentType } from '../types';
import {
  DEVELOPMENT_TYPE_OPTIONS,
  CLASS_AND_LOGISTICS_REQ_DEV_TYPES,
} from '../constants';
import { ProductImageSection } from './ProductImageSection';

export function ProtoFieldsSection() {
  const { control, watch, setValue } = useFormContext<AddTagFormData>();
  const typeOfDevelopment = watch('typeOfDevelopment');
  const prevTypeRef = useRef<DevelopmentType | undefined>(undefined);

  useEffect(() => {
    if (
      typeOfDevelopment &&
      prevTypeRef.current &&
      prevTypeRef.current !== typeOfDevelopment
    ) {
      if (typeOfDevelopment !== DevelopmentType.SAMPLE_REQUEST) {
        setValue('styleName', undefined);
      }

      const needsClassAndLogistics =
        CLASS_AND_LOGISTICS_REQ_DEV_TYPES.includes(typeOfDevelopment);

      if (!needsClassAndLogistics) {
        setValue('customCutLeadTime', undefined);
        setValue('ccLeadTimeDate', undefined);
        setValue('coo', undefined);
        setValue('shipmentMode', undefined);
        setValue('division', undefined);
        setValue('department', undefined);
        setValue('category', undefined);
        setValue('class', undefined);
      }
    }

    prevTypeRef.current = typeOfDevelopment;
  }, [typeOfDevelopment, setValue]);

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <ControlledFormInput
        name="typeOfDevelopment"
        label="Type of Development"
        control={control}
        inputType="select"
        required
        inputProps={{
          placeholder: 'Select..',
          className: 'w-full',
          options: DEVELOPMENT_TYPE_OPTIONS,
        }}
      />

      <ProductImageSection showWrapper={false} />

      {typeOfDevelopment === DevelopmentType.SAMPLE_REQUEST && (
        <ControlledFormInput
          name="styleName"
          label="Style Name"
          control={control}
          inputType="text"
          required
          inputProps={{
            placeholder: 'Add',
            className: 'w-full',
          }}
        />
      )}

      <div className="grid grid-cols-2 gap-4">
        <ControlledFormInput
          name="sampleSize"
          label="Sample Size"
          control={control}
          inputType="text"
          required
          inputProps={{
            placeholder: 'ie. XS',
            className: 'w-full',
          }}
        />
        <ControlledFormInput
          name="colorWash"
          label="Color/Wash"
          control={control}
          inputType="text"
          required
          inputProps={{
            placeholder: 'ie. Black',
            className: 'w-full',
          }}
        />
      </div>
    </div>
  );
}
